import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from './router'
import store from './store/'
import scroll from 'vue-seamless-scroll'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
// import 'lib-flexible/flexible'
import "./assets/css/bootstrap.min.css"
import { isMobile } from './utils';
// 注册全局方法
Vue.prototype.$isMobile = isMobile();
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(scroll)
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: '7Ygi1dMTMX3VfftwIyEaBCRrFGP1ODBX'
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

/* filters */
import * as filters from '@/filters';
Object.keys(filters).forEach(v => {
  Vue.filter(v, filters[v]);
});